import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import {
  CURRENCY,
  TABLE_ITEMS,
  TOTAL,
  WAFFY_FEES,
  TABBY_FEES,
  NEO_FEES,
  TAMARA_FEES,
} from "./constants";
import { IContractProps } from "../../models";

// styles
import styles from "./styles.module.css";
import classNames from "classnames";
import { useMemo } from "react";
import {
  EFeePayee,
  ETrasactionsType,
} from "../../../../setup/api/services/contract/models";

const SellerPaymentDetails = ({ contract }: IContractProps) => {
  function createRow(desc: string, price: number | string) {
    return { desc, price };
  }

  const tabbyAllowed = useMemo(() => {
    return contract?.transactions?.some(
      (transaction) =>
        transaction?.type === ETrasactionsType.CUSTOMER_PAY &&
        transaction?.paymentMethod === "TABBY"
    );
  }, [contract]);

  const neoAllowed = useMemo(() => {
    return contract?.transactions?.some(
      (transaction) =>
        transaction?.type === ETrasactionsType.CUSTOMER_PAY &&
        transaction?.paymentMethod === "NEO"
    );
  }, [contract]);

  const tamaraAllowed = useMemo(() => {
    return contract?.transactions?.some(
      (transaction) =>
        transaction?.type === ETrasactionsType.CUSTOMER_PAY &&
        transaction?.paymentMethod === "TAMARA"
    );
  }, [contract]);

  const subTotal = useMemo(() => {
    return contract?.hasVoucher
      ? contract?.originalItemPrice || contract?.itemPrice
      : contract?.itemPrice;
  }, [contract?.hasVoucher, contract?.itemPrice, contract?.originalItemPrice]);

  const total = useMemo(() => {
    if (contract.feePayee === EFeePayee.CUSTOMER) return subTotal;
    return subTotal - contract?.fee;
  }, [contract?.fee, contract.feePayee, subTotal]);

  const rows = [
    createRow(
      TABLE_ITEMS.NET_PRICE,
      contract?.originalItemPrice || contract?.itemPrice || 0
    ),
    createRow(TABLE_ITEMS.SUB_TOTAL, subTotal || 0),
  ];
  return (
    <TableContainer className={styles.container}>
      <Table aria-label="spanning table">
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={row.desc}>
              <TableCell
                className={classNames(
                  index + 1 !== rows.length
                    ? styles.table_cell
                    : styles.table_cell_strong
                )}>
                {row.desc}
              </TableCell>
              <TableCell
                className={classNames(
                  index + 1 !== rows.length
                    ? styles.table_cell
                    : styles.price_subtotal
                )}
                align="right">
                {Number(row.price)?.toFixed(2)}{" "}
                <span className={styles.currency}>{CURRENCY}</span>
              </TableCell>
            </TableRow>
          ))}
          {contract.feePayee !== EFeePayee.CUSTOMER && (
            <TableRow>
              <TableCell className={classNames(styles.table_cell, styles.desc)}>
                {tabbyAllowed
                  ? TABBY_FEES
                  : neoAllowed
                  ? NEO_FEES
                  : tamaraAllowed
                  ? TAMARA_FEES
                  : WAFFY_FEES}
              </TableCell>

              <TableCell
                className={classNames(styles.table_cell, styles.price)}
                align="right">
                {"- "}
                {contract?.fee?.toFixed(2)}{" "}
                <span className={styles.currency}>{CURRENCY}</span>
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell className={classNames(styles.table_cell, styles.total)}>
              {TOTAL}
            </TableCell>
            <TableCell
              className={classNames(
                styles.table_cell,
                styles.price_total,
                styles.doneText
              )}
              align="right">
              {total?.toFixed(2)}{" "}
              <span className={styles.currency}>{CURRENCY}</span>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SellerPaymentDetails;
